import { scrollToId } from "@/lib/scroll";

const links = [
  { label: "Il Corso", href: "#programma" },
  { label: "Destinatari", href: "#destinatari" },
  { label: "Requisiti", href: "#requisiti" },
  { label: "Prezzo", href: "#prezzo" },
  { label: "Iscriviti", href: "#iscriviti" },
  { label: "FAQ", href: "#faq" },
];

export default function Footer() {
  return (
    <footer className="bg-navy-deep pb-24 pt-14 text-white md:pb-14" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col gap-10 md:flex-row md:items-start md:justify-between">
          <div className="max-w-sm">
            <div className="flex items-center gap-3">
              <img
                src="/logo-anas.png"
                alt="Logo ANAS Milano Formazione"
                className="h-10 w-10 rounded-full object-cover"
                data-testid="footer-logo-image"
              />
              <span className="font-heading text-lg font-bold tracking-tight">ANAS Milano Formazione</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-slate-400">
              Corso SAB (ex REC) — Somministrazione di Alimenti e Bevande.
              Abilitazione obbligatoria valida in tutta Italia, in presenza a Milano e online.
            </p>
          </div>
          <nav className="flex flex-wrap gap-x-8 gap-y-3" data-testid="footer-nav">
            {links.map((l) => (
              <button
                key={l.href}
                onClick={() => scrollToId(l.href)}
                className="text-sm font-medium text-slate-300 transition-colors hover:text-brand-amber"
                data-testid={`footer-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              >
                {l.label}
              </button>
            ))}
          </nav>
        </div>
        <div className="mt-10 flex flex-col gap-2 border-t border-white/10 pt-6 text-xs text-slate-500 sm:flex-row sm:items-center sm:justify-between">
          <p data-testid="footer-copyright">© 2026 ANAS Milano Formazione — Tutti i diritti riservati.</p>
          <p className="flex items-center gap-4">
            <span>Via Mazzali 5, Milano · +39 351 393 7976 · formazione@anasmilano.com</span>
            <a href="/privacy" className="font-semibold text-slate-300 underline underline-offset-2 transition-colors hover:text-brand-amber" data-testid="footer-privacy-link">
              Privacy Policy
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
